<template>
  <div class="resource-container">
    <b-row align-v="start">
      <b-col
        cols="12"
        lg="4"
        md="6"
        sm="6"
        xs="12"
        class="mb-3"
        v-for="resource in resources"
        v-bind:key="resource.id"
      >
        <ResourceCard v-bind:resource="resource"></ResourceCard>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import ResourceCard from './ResourceCard'

export default {
  name: 'resources',
  components: {
    ResourceCard
  },
  props: {
    'resources': Array
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/resources/ResourcesList.vue